"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Parser = void 0;
const sdk_1 = require("@yfi/sdk");
const ethers_1 = require("ethers");
const types_1 = require("../../types");
const shapeShiftRouter_1 = __importDefault(require("./abi/shapeShiftRouter"));
const yearnVault_1 = __importDefault(require("./abi/yearnVault"));
const constants_1 = require("./constants");
const utils_1 = require("./utils");
class Parser {
    constructor(args) {
        this.shapeShiftInterface = new ethers_1.ethers.utils.Interface(shapeShiftRouter_1.default);
        this.yearnInterface = new ethers_1.ethers.utils.Interface(yearnVault_1.default);
        this.supportedYearnFunctions = {
            approveSigHash: this.yearnInterface.getSighash('approve'),
            depositSigHash: this.yearnInterface.getSighash('deposit()'),
            depositAmountSigHash: this.yearnInterface.getSighash('deposit(uint256)'),
            depositAmountAndRecipientSigHash: this.yearnInterface.getSighash('deposit(uint256,address)'),
            withdrawSigHash: this.yearnInterface.getSighash('withdraw(uint256,address)')
        };
        this.supportedShapeShiftFunctions = {
            depositSigHash: this.shapeShiftInterface.getSighash('deposit(address,address,uint256,uint256)')
        };
        this.provider = args.provider;
        // The only Yearn-supported chain we currently support is mainnet
        if (args.chainId === 'eip155:1') {
            // 1 for EthMain (@yfi/sdk/dist/chain.d.ts)
            this.yearnSdk = new sdk_1.Yearn(1, { provider: this.provider });
        }
    }
    async parse(tx) {
        var _a, _b, _c, _d, _e;
        const txData = (_a = tx.ethereumSpecific) === null || _a === void 0 ? void 0 : _a.data;
        if (!txData)
            return;
        const txSigHash = (0, utils_1.getSigHash)(txData);
        const abiInterface = this.getAbiInterface(txSigHash);
        if (!abiInterface)
            return;
        if (!this.yearnTokenVaultAddresses) {
            const vaults = await ((_b = this.yearnSdk) === null || _b === void 0 ? void 0 : _b.vaults.get());
            this.yearnTokenVaultAddresses = vaults === null || vaults === void 0 ? void 0 : vaults.map((vault) => vault.address);
        }
        const decoded = abiInterface.parseTransaction({ data: txData });
        // failed to decode input data
        if (!decoded)
            return;
        const receiveAddress = (_d = (_c = tx.vout) === null || _c === void 0 ? void 0 : _c[0].addresses) === null || _d === void 0 ? void 0 : _d[0];
        switch (txSigHash) {
            case this.supportedYearnFunctions.approveSigHash:
                if ((decoded === null || decoded === void 0 ? void 0 : decoded.args._spender) !== constants_1.SHAPE_SHIFT_ROUTER_CONTRACT)
                    return;
                break;
            case this.supportedShapeShiftFunctions.depositSigHash:
                if (receiveAddress !== constants_1.SHAPE_SHIFT_ROUTER_CONTRACT)
                    return;
                break;
            case this.supportedYearnFunctions.withdrawSigHash:
            case this.supportedYearnFunctions.depositSigHash:
            case this.supportedYearnFunctions.depositAmountSigHash:
            case this.supportedYearnFunctions.depositAmountAndRecipientSigHash:
                if (receiveAddress && !((_e = this.yearnTokenVaultAddresses) === null || _e === void 0 ? void 0 : _e.includes(receiveAddress)))
                    return;
                break;
            default:
                return;
        }
        return {
            data: {
                method: decoded.name,
                parser: types_1.TxParser.Yearn
            }
        };
    }
    getAbiInterface(txSigHash) {
        if (Object.values(this.supportedYearnFunctions).some((abi) => abi === txSigHash))
            return this.yearnInterface;
        if (Object.values(this.supportedShapeShiftFunctions).some((abi) => abi === txSigHash))
            return this.shapeShiftInterface;
        return undefined;
    }
}
exports.Parser = Parser;
